import { gql } from "@apollo/client";

export const CATEGORIES_QUERY = gql`
  {
    categories {
      items {
        id
        name
        level
        include_in_menu  # ✅ Add this field
        children {
          id
          name
          level
          include_in_menu  # ✅ Add for children too
          children {
            id
            name
            level
            include_in_menu  # ✅ Add for deeper levels
            children {
              id
              name
              level
            }
          }
        }
      }
    }
  }
`;
